var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclamationMarkSign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.951,
    height: 33.495,
    viewBox: "0 0 38.951 33.495",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27689",
    "data-name": "Group 27689",
    transform: "translate(-712.553 -159.234)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "danger",
    transform: "translate(712.553 159.234)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23328",
    "data-name": "Group 23328",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23327",
    "data-name": "Group 23327",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3918",
    "data-name": "Path 3918",
    d: "M38.448,64.046l-15.977-26.5a3.5,3.5,0,0,0-5.993,0L.5,64.046a3.5,3.5,0,0,0,3,5.306H35.452a3.5,3.5,0,0,0,3-5.306ZM36.29,66.326a.965.965,0,0,1-.839.49H3.5a.963.963,0,0,1-.825-1.461l15.977-26.5a.963.963,0,0,1,1.65,0l15.977,26.5A.964.964,0,0,1,36.29,66.326Z",
    transform: "translate(0 -35.857)",
    fill: "#f4906a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23340",
    "data-name": "Group 23340",
    transform: "translate(730.658 169.111)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3915",
    "data-name": "Path 3915",
    d: "M235.032,84.338c-.756,0-1.369.441-1.369.984v9.842c0,.544.613.984,1.369.984s1.369-.441,1.369-.984V85.322C236.4,84.779,235.789,84.338,235.032,84.338Z",
    transform: "translate(-233.663 -84.338)",
    fill: "#f4906a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3916",
    "data-name": "Path 3916",
    d: "M235.032,383a1.369,1.369,0,1,0,1.369,1.369A1.37,1.37,0,0,0,235.032,383Z",
    transform: "translate(-233.663 -368.455)",
    fill: "#f4906a"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMarkSign);
export default __webpack_public_path__ + "static/media/exclamation_mark-sign.f25f49821715ed0503faadbe068ac347.svg";
export { ForwardRef as ReactComponent };